// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediasfu-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-top: 0px;
}

.mediasfu-container .buttonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 5px;
  margin-right: 4px;
  font-size: medium;
  border: none;
}

.mediasfu-container .buttonContainer:hover {
  cursor: pointer;
}

.mediasfu-container .verticalButton {
  flex-direction: column;
}

.mediasfu-container .buttonText {
  font-size: 12px;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/displayComponents/ControlButtonsComponent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":[".mediasfu-container {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: row;\r\n  margin-top: 0px;\r\n}\r\n\r\n.mediasfu-container .buttonContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  margin-right: 4px;\r\n  font-size: medium;\r\n  border: none;\r\n}\r\n\r\n.mediasfu-container .buttonContainer:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.mediasfu-container .verticalButton {\r\n  flex-direction: column;\r\n}\r\n\r\n.mediasfu-container .buttonText {\r\n  font-size: 12px;\r\n  margin-top: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
